import { render, staticRenderFns } from "./originTracing.vue?vue&type=template&id=ddbeb0ce&scoped=true&"
import script from "./originTracing.vue?vue&type=script&lang=js&"
export * from "./originTracing.vue?vue&type=script&lang=js&"
import style0 from "./originTracing.vue?vue&type=style&index=0&id=ddbeb0ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbeb0ce",
  null
  
)

export default component.exports